var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 308,
    viewBox: "0 0 308 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.843 307.686C145.577 307.686 137.28 307.024 129.201 305.721C93.5204 299.979 60.8193 281.637 37.1288 254.078C13.1798 226.218 0 190.62 0 153.843C0 69.0126 69.0127 0 153.853 0C238.694 0 307.707 69.0126 307.707 153.843C307.707 191.189 294.155 227.211 269.554 255.257C245.181 283.044 211.693 301.138 175.278 306.217C168.233 307.2 161.033 307.697 153.864 307.697L153.843 307.686ZM153.843 12.4039C75.8508 12.4039 12.4039 75.8508 12.4039 153.833C12.4039 223.663 62.3504 282.382 131.177 293.462C145.05 295.696 159.595 295.852 173.551 293.907C242.946 284.234 295.282 224.014 295.282 153.833C295.282 75.8508 231.835 12.4039 153.843 12.4039Z",
    fill: "#1877F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.399 124.742V156.905H214.187L207.886 200.231H174.399V300.052C167.685 300.983 160.816 301.469 153.843 301.469C145.795 301.469 137.891 300.828 130.194 299.586V200.231H93.4998V156.905H130.194V117.552C130.194 93.1376 149.984 73.337 174.409 73.337V73.3577C174.482 73.3577 174.544 73.337 174.616 73.337H214.197V110.807H188.334C180.648 110.807 174.409 117.045 174.409 124.732L174.399 124.742Z",
    fill: "#1877F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c0a58fd02794f3551dd58d737e0bdf83.svg";
export { ForwardRef as ReactComponent };